// extracted by css-extract-rspack-plugin
export default {"loadingState":"loadingState-Xhy1k7"};